/**
 * Slider Component
 *
 * @file handWoven.js
 */

import $ from "jquery";
import fullpage from 'fullpage.js';
import 'fullpage.js/dist/fullpage.css';
const handWoven = (() => {
const overflowEllipsis = () => {
    // function updateEllipsisWidth() {
    //     const ellipsisElements = document.querySelectorAll('.overflow-ellipsis');
    //     ellipsisElements.forEach(element => {
    //         const parentWidth = element.parentElement.parentElement.offsetWidth;
    //         element.style.width = parentWidth + 'px';
    //     });
    // }
    
    // document.addEventListener('DOMContentLoaded', updateEllipsisWidth);
    // window.addEventListener('resize', updateEllipsisWidth); 
}
const handWovenScrollAnim = () => {

    window.addEventListener('scroll', function() {
        const pageToTop = document.querySelector('.page-to-top');
        const trialPopup = document.querySelector('.trial-product-popup');
        if(pageToTop){
            if (window.scrollY > 200) {
                if (trialPopup) {
                    pageToTop.classList.add('popup-active');
                    pageToTop.classList.remove('active');
                } else {
                    pageToTop.classList.add('active');
                    pageToTop.classList.remove('popup-active');
                }
            } else {
                pageToTop.classList.remove('active', 'popup-active');
            }
        }
    });
    if (document.querySelector('.page-to-top')){
        document.querySelector('.page-to-top').addEventListener('click', function() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

  if(document.getElementById("hand-woven-page-anim")){
    const divElements = document.querySelectorAll('.dt-mt-sub-title');

    function wrapTextInSpan(element) {
        let delay = 0;
        const fragment = document.createDocumentFragment();
        
        // İçeriği geçici bir div'e koyarak HTML'i parse edelim
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = element.innerHTML;
        
        function processNode(node) {
            if (node.nodeType === Node.TEXT_NODE) {
                const text = node.textContent.trim();
                if (text) {
                    const words = text.split(/(\s+)/g);
                    words.forEach(word => {
                        if (word.trim().length > 0) {
                            const span = document.createElement('span');
                            span.textContent = word;
                            span.style.transitionDelay = `${delay.toFixed(1)}s`;
                            delay += 0.017;
                            fragment.appendChild(span);
                        } else {
                            fragment.appendChild(document.createTextNode('\u00A0'));
                        }
                    });
                }
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.tagName === 'BR') {
                    fragment.appendChild(document.createElement('br'));
                } else {
                    const newElement = node.cloneNode(false);
                    Array.from(node.childNodes).forEach(child => {
                        processNode(child);
                    });
                    fragment.appendChild(newElement);
                }
            }
        }

        Array.from(tempContainer.childNodes).forEach(processNode);

        // Eski içeriği temizle
        element.innerHTML = '';
        // Yeni içeriği ekle
        element.appendChild(fragment);
    }

    const divElementsDesc = document.querySelectorAll('.dt-mt-desc');

    function wrapTextInSpanDesc(elements) {
        let delay = 0;
        const nodesDesc = Array.from(elements.childNodes);

        nodesDesc.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                const textContent = node.textContent.trim();
                if (textContent) {
                    const spanWrappedText = textContent.split(/(\s+)/g).map(word => {
                        if (word.trim().length > 0) {
                            delay += 0.01;
                            return `<span style="transition-delay:${delay.toFixed(1)}s">${word}</span>`;
                        }
                        return '&nbsp;'; // Boşlukları &nbsp; ile değiştir
                    }).join('');

                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = spanWrappedText;

                    while (tempDiv.firstChild) {
                        elements.insertBefore(tempDiv.firstChild, node);
                    }
                    elements.removeChild(node);
                }
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.tagName === 'BR') {
                    // BR etiketini olduğu gibi bırak
                    elements.insertBefore(node, node);
                } else {
                    wrapTextInSpanDesc(node);
                }
            }
        });
    }


    divElements.forEach(div => {
        wrapTextInSpan(div);
    });
    divElementsDesc.forEach(div => {
        wrapTextInSpanDesc(div);
    });







    let canScroll = true;

    new fullpage('#hand-woven-page-anim', {
        navigation: true,
        navigationPosition: 'right',
        navigationTooltips: ['', '', '01/08', '02/08', '03/08', '04/08', '05/08', '06/08', '07/08', '08/08', '', ''],
        easingcss3: "ease-in-out",
        scrollingSpeed: 1000,
        responsiveWidth: 680,
        overflowScroll: false,
        afterResponsive: function(isResponsive) {
            if (isResponsive) {
                document.querySelector('#fp-nav').style.display = 'block';
            }
        },
        onLeave: function (origin, destination, direction, trigger) {
            if (!canScroll) {
                return false; // Scroll durdurulur
            }
            canScroll = false; // Scroll başlatılır
            setTimeout(() => {
                canScroll = true; // Belirtilen süre sonunda scroll tekrar açılır
            }, 1500); // 3 saniye bekleme süresi
        },
        afterLoad: function (origin, destination, direction) {
            document.querySelector('.banner-scroll-bottom').addEventListener('click', () => {
                fullpage_api.moveSectionDown();
            });
            const sectionActions = (sectionIndex) => {
                const spans = document.querySelectorAll('.fp-section.active .dt-mt-sub-title span');
                const spansDesc = document.querySelectorAll('.fp-section.active .dt-mt-desc span');
                const descImg = document.querySelectorAll('.fp-section.active .img');
                
                const desktopImg = document.querySelector('.fp-section.active .dt-desktop-img');
                const mobileImg = document.querySelector('.fp-section.active .dmt-mobile-img');
                if (desktopImg) {
                    // document.querySelectorAll('.dt-desktop-img').forEach(img => {
                    //     img.classList.remove('reveal');
                    // });
                    desktopImg.classList.add('reveal');
                    mobileImg.classList.add('reveal');
                }
                
                $(`.fp-section.active .el-icon, .fp-section.active .dt-mt-title, .fp-section.active .i-el-line`).addClass("active");
                spans.forEach(span => {
                    span.classList.add('show');
                });
                spansDesc.forEach(span => {
                    span.classList.add('show');
                });
                descImg.forEach(span => {
                    span.classList.add('active');
                });
            }
    
            if ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(destination.index)) {
                sectionActions(destination.index);
            }
            if ([2, 3, 4, 5, 6, 7, 8, 9].includes(destination.index)) {
                $("#fp-nav").addClass("active");
                $(".page-to-top").addClass("active");
            }
            if (destination.index >= 2) {
                $('.i-el-line').addClass("left-deg");
            }
            if ([0, 1, 10].includes(destination.index)) {
                $("#fp-nav").removeClass("active");
                $(".page-to-top").removeClass("active");
            }
        },
    });
    const elLines = document.querySelectorAll('.i-el-line svg');
    elLines.forEach(line => {
        line.addEventListener('click', () => {
            fullpage_api.moveSectionDown();
        });
    });
    document.querySelector('.page-to-top').addEventListener('click', function () {
        fullpage_api.moveTo(1);
        $("#fp-nav").removeClass("active");
        $(".page-to-top").removeClass("active");
    });

  }

}

  const init = () => {
    handWovenScrollAnim();
    overflowEllipsis();
  };

  return {
    init,
  };
})();

export default handWoven;
